import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { signOut } from "../../redux/actions/user";

import {
    Navbar,
    Nav,
    NavItem,
    NavDropdown,
    MenuItem,
} from "react-bootstrap";

class HeaderLinks extends Component {
    render() {
        const { profile } = this.props;

        return (
            <div>
                <Navbar.Form pullLeft className="navbar-search-form">
                    {/*
            <FormGroup>
              <InputGroup>
                <InputGroup.Addon>
                  <i className="fa fa-search" />
                </InputGroup.Addon>
                <FormControl type="text" placeholder="Rechercher Id..." />
              </InputGroup>
            </FormGroup>
          */}
                </Navbar.Form>
                <Nav pullRight>

                    {(profile && (profile.role === "super" || profile.role === "admin")) ? (
                        <>
                            <NavDropdown
                                eventKey={2}
                                title={
                                    <div style={{ 
                                        padding: '8px 15px', 
                                        borderRadius: '25px',
                                        background: '#3b97ff',
                                        color: 'white',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        minWidth: '140px',
                                        justifyContent: 'center'
                                    }}>
                                        <i className="fa fa-cogs" style={{ fontSize: '16px' }} />
                                        <span>Administration</span>
                                        <p className="hidden-md hidden-lg" style={{ margin: 0 }}>
                                            <b className="caret" />
                                        </p>
                                    </div>
                                }
                                noCaret
                                id="admin-nav-dropdown"
                                bsClass="dropdown-with-icons dropdown"
                            >
                                <MenuItem
                                    eventKey={2.1}
                                    onClick={() => this.props.history.push("/app/admin/dashboard")}
                                    style={{
                                        padding: '12px 20px',
                                        fontSize: '15px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <i className="pe-7s-graph" style={{
                                            fontSize: '18px',
                                            color: '#007bff',
                                            width: '20px',
                                            textAlign: 'center'
                                        }} />
                                        <span>Tableau de bord</span>
                                    </div>
                                </MenuItem>
                                <MenuItem
                                    eventKey={2.2}
                                    onClick={() => this.props.history.push("/app/admin/users")}
                                    style={{
                                        padding: '12px 20px',
                                        fontSize: '15px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <i className="pe-7s-users" style={{
                                            fontSize: '18px',
                                            color: '#764ba2',
                                            width: '20px',
                                            textAlign: 'center'
                                        }} />
                                        <span>Gestion Utilisateurs</span>
                                    </div>
                                </MenuItem>
                                <MenuItem 
                                    eventKey={2.3}
                                    onClick={() => this.props.history.push("/app/admin/training")}
                                    style={{
                                        padding: '12px 20px',
                                        fontSize: '15px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <i className="pe-7s-study" style={{
                                            fontSize: '18px',
                                            color: '#28a745',
                                            width: '20px',
                                            textAlign: 'center'
                                        }} />
                                        <span>Gestion Formations</span>
                                    </div>
                                </MenuItem>
                                <MenuItem 
                                    eventKey={2.4}
                                    onClick={() => this.props.history.push("/app/admin/experiences")}
                                    style={{
                                        padding: '12px 20px',
                                        fontSize: '15px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <i className="pe-7s-share" style={{
                                            fontSize: '18px',
                                            color: '#e74c3c',
                                            width: '20px',
                                            textAlign: 'center'
                                        }} />
                                        <span>Gestion Expériences</span>
                                    </div>
                                </MenuItem>
                                <MenuItem 
                                    eventKey={2.5}
                                    onClick={() => this.props.history.push("/app/admin/subscriptions")}
                                    style={{
                                        padding: '12px 20px',
                                        fontSize: '15px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <i className="pe-7s-star" style={{
                                            fontSize: '18px',
                                            color: '#f39c12',
                                            width: '20px',
                                            textAlign: 'center'
                                        }} />
                                        <span>Gestion Abonnements</span>
                                    </div>
                                </MenuItem>
                                <MenuItem
                                    eventKey={2.6}
                                    onClick={() => this.props.history.push("/app/product/form/0")}
                                    style={{ 
                                        padding: '12px 20px',
                                        fontSize: '15px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <i className="fa fa-plus" style={{ 
                                            fontSize: '18px', 
                                            color: 'var(--app-primary-color)',
                                            width: '20px',
                                            textAlign: 'center'
                                        }} />
                                        <span>Ajouter Produit</span>
                                    </div>
                                </MenuItem>
                                <MenuItem
                                    eventKey={2.7}
                                    onClick={() => this.props.history.push("/app/admin/professions")}
                                    style={{
                                        padding: '12px 20px',
                                        fontSize: '15px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <i className="pe-7s-portfolio" style={{
                                            fontSize: '18px',
                                            color: '#9b59b6',
                                            width: '20px',
                                            textAlign: 'center'
                                        }} />
                                        <span>Gestion des Professions</span>
                                    </div>
                                </MenuItem>
                                 <MenuItem
                                 eventKey={2.8}
                                 onClick={() => this.props.history.push("/app/admin/database")}
                                 style={{
                                   padding: '12px 20px',
                                   fontSize: '15px',
                                   fontWeight: '500'
                                 }}
                               >
                                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                   <i className="pe-7s-server" style={{
                                     fontSize: '18px',
                                     color: 'var(--app-primary-color)',
                                     width: '20px',
                                     textAlign: 'center'
                                   }} />
                                   <span>Base de Données</span>
                                 </div>
                               </MenuItem>
                               <MenuItem
                                 eventKey={2.9}
                                 onClick={() => this.props.history.push("/app/admin/statistics")}
                                 style={{
                                   padding: '12px 20px',
                                   fontSize: '15px',
                                   fontWeight: '500'
                                 }}
                               >
                                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                   <i className="pe-7s-graph2" style={{
                                     fontSize: '18px',
                                     color: '#28a745',
                                     width: '20px',
                                     textAlign: 'center'
                                   }} />
                                   <span>Statistiques & Impact Sanitaire</span>
                                 </div>
                               </MenuItem>
                               <MenuItem
                                 eventKey={2.10}
                                 onClick={() => this.props.history.push("/app/admin/reports")}
                                 style={{
                                   padding: '12px 20px',
                                   fontSize: '15px',
                                   fontWeight: '500'
                                 }}
                               >
                                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                   <i className="pe-7s-note" style={{
                                     fontSize: '18px',
                                     color: '#6f42c1',
                                     width: '20px',
                                     textAlign: 'center'
                                   }} />
                                   <span>Rapports générés</span>
                                 </div>
                               </MenuItem>
                            </NavDropdown>
                        </>
                    ) : null}

                    <NavDropdown
                        eventKey={4}
                        title={
                            <div style={{ 
                                padding: '8px 15px', 
                                borderRadius: '25px',
                                background: '#f8f9fc',
                                color: '#333',
                                fontWeight: '600',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                minWidth: '120px',
                                justifyContent: 'center',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                border: '1px solid #e3e6f0'
                            }}>
                                <i className="pe-7s-tools" style={{ fontSize: '16px', color: '#4e73df' }} />
                                <span>Paramètres</span>
                                <p className="hidden-md hidden-lg" style={{ margin: 0 }}>
                                    <b className="caret" />
                                </p>
                            </div>
                        }
                        noCaret
                        id="basic-nav-dropdown-3"
                        bsClass="dropdown-with-icons dropdown"
                    >
                        <MenuItem eventKey={4.1} onClick={() => this.props.history.push("/app/profile")}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <i className="pe-7s-user" style={{ fontSize: '18px', color: '#5a5c69' }} /> 
                                <span>Mon Profil</span>
                            </div>
                        </MenuItem>
                        
                        <MenuItem eventKey={4.2} onClick={() => this.props.history.push("/app/subscription")}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <i className="pe-7s-star" style={{ fontSize: '18px', color: '#f39c12' }} /> 
                                <span>Gestion Abonnement</span>
                            </div>
                        </MenuItem>

                        <MenuItem divider />
                        <MenuItem eventKey={4.5} onClick={() => { this.props.signOut(); }}>
                            <div className="text-danger" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <i className="pe-7s-power" style={{ fontSize: '18px' }} /> 
                                <span>Déconnexion</span>
                            </div>
                        </MenuItem>
                    </NavDropdown>
                </Nav>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.user.profile,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signOut: () => {
            dispatch(signOut());
        },
    };
};

HeaderLinks.propTypes = {
    history: PropTypes.object,
    profile: PropTypes.object,
    signOut: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLinks);
